// extracted by mini-css-extract-plugin
module.exports = {"segment":"Segment_segment__1f5mn","segment__container":"Segment_segment__container__zMyoL","segment__title":"Segment_segment__title__Nta_i"};